import type { IconTileProps } from '@atlaskit/icon/types';

// ---------------------------------------------------------------------------
// Color / Appearance Resolution
// ---------------------------------------------------------------------------

/**
 * Maps an API `color` string to an Atlaskit IconTile appearance.
 * Keys are aligned with IconTileAppearance values.
 * Falls back to 'blueBold' for unknown values.
 */
export const COLOR_TO_APPEARANCE: Record<string, IconTileProps['appearance']> = {
	gray: 'gray',
	blue: 'blue',
	teal: 'teal',
	green: 'green',
	lime: 'lime',
	yellow: 'yellow',
	orange: 'orange',
	red: 'red',
	magenta: 'magenta',
	purple: 'purple',
	grayBold: 'grayBold',
	blueBold: 'blueBold',
	tealBold: 'tealBold',
	greenBold: 'greenBold',
	limeBold: 'limeBold',
	yellowBold: 'yellowBold',
	orangeBold: 'orangeBold',
	redBold: 'redBold',
	magentaBold: 'magentaBold',
	purpleBold: 'purpleBold',
};
